import { Key } from 'react';

export const transformObjectToArray = <TData>(
  data: Record<string, TData>,
): (TData & { key: Key })[] =>
  Object.entries(data).reduce<(TData & { key: string })[]>(
    (acc, [key, values]) => [...acc, { ...values, key }],
    [],
  );
